export default __webpack_public_path__ + "static/media/1551.29239659.png";